export function GetEmbeddingCollectionExportUrl(workspaceId: string, embeddingCollectionId: string) {
    var url = `/api/EmbeddingCollectionDataTool/Export?workspaceId=${workspaceId}&embeddingCollectionId=${embeddingCollectionId}`
    return url
}
export function GetEmbeddingCollectionDataUrl(workspaceId: string, collectionId?: string, dataId?: string) {
    return `/workspace/${workspaceId}/embeddingCollection/${collectionId ?? ""}/${dataId ?? ""}`
}
export function GetTestSetExportUrl(workspaceId: string, id: string) {
    var url = `/api/ChatEvaluationTestSet/Export?workspaceId=${workspaceId}&id=${id}`
    return url
}
export function GetPublicChatUrl(workspaceId: string, chatBotDataId: string, accessKey?: string) {
    var url = `/workspace/${workspaceId}/chatBotData/${chatBotDataId}/publicChat`
    if (accessKey) {
        url += `?accessKey=${accessKey}`
    }
    return url
}
export function GetWebBotAvatarUrl(botProviderId: string) {
    return `/api/WebBot/avatarIcon/${botProviderId}?t=${new Date().getTime()}`
}
export function GetWebBotWidgetUrl(botProviderId: string) {
    return `/api/WebBot/widgetIcon/${botProviderId}?t=${new Date().getTime()}`
}
export function GetWebBotBackgroundImageUrl(botProviderId: string) {
    return `/api/WebBot/backgroundImage/${botProviderId}?t=${new Date().getTime()}`
}
export function GetWebBotBundleUrl(botProviderId: string, filePath: string) {
    const clean = filePath.replace(/^\/+/, '')
    const encodedPath = clean.split('/').map(encodeURIComponent).join('/')
    return `/api/WebBot/bundle/${botProviderId}/${encodedPath}`
}
export function GetWebBotRuntimeUrl(filePath: string) {
    const clean = filePath.replace(/^\/+/, '')
    const encodedPath = clean.split('/').map(encodeURIComponent).join('/')
    return `/api/WebBot/runtime/${encodedPath}`
}
export function GetBotProviderAssetBundleDownloadZipUrl(workspaceId: string, botProviderId: string, bundleName: string) {
    return `/api/BotProviderAssetBundle/DownloadZip?workspaceId=${workspaceId}&botProviderId=${botProviderId}&bundleName=${encodeURIComponent(bundleName)}`
}
export function GetBotProviderCustomUiDownloadZipUrl(workspaceId: string, botProviderId: string) {
    return `/api/BotProviderCustomUi/DownloadZip?workspaceId=${workspaceId}&botProviderId=${botProviderId}`
}
export function GetWebBotCustomUiUrl(botProviderId: string, filePath: string) {
    const clean = filePath.replace(/^\/+/, '')
    const encodedPath = clean.split('/').map(encodeURIComponent).join('/')
    return `/api/WebBot/custom/${botProviderId}/${encodedPath}`
}